import React from 'react';

import { useTranslation } from 'react-i18next';

import { isTabletOrWeb, isWeb } from 'utils/responsiveness';
import { applyBoldStyle } from 'utils/strings';

import styles from 'components/Dialog/style';
import { DialogProps } from 'components/Dialog/types';
import Text, { ETextCategory, ETextColor } from 'components/Text';

type Props = Pick<
    DialogProps,
    | 'description'
    | 'DescriptionComponent'
    | 'descriptionTestID'
    | 'descriptionNumberOfLines'
>;

export default function DialogDescription({
    description,
    DescriptionComponent,
    descriptionTestID,
    descriptionNumberOfLines = isTabletOrWeb ? 3 : 4,
}: Props) {
    const { t } = useTranslation();

    if (DescriptionComponent) {
        return <DescriptionComponent />;
    }

    if (description) {
        return (
            <Text
                category={ETextCategory.body1}
                color={ETextColor.light_grey}
                style={[styles.description, styles.text]}
                numberOfLines={descriptionNumberOfLines}
                testID={descriptionTestID}
                accessibilityRole="text"
                accessibilityLabel={t(description)}
                {...(isWeb && { tabIndex: 0 })}
                accessible
            >
                {applyBoldStyle(t(description))}
            </Text>
        );
    }

    return null;
}
